import { extractionBrowserName } from "@/utils/extractionBrowserName";
import { useEffect, useState } from "react";
import { browserName } from "react-device-detect";

/* 推奨ブラウザ判定 */
export const useRecBrowserJudge = () => {
  const [isRecommendedBrowser, setIsRecommendedBrowser] = useState(false);

  useEffect(() => {
    if (browserName) {
      // 推奨ブラウザかどうか
      const extBrowserName = extractionBrowserName(browserName);
      setIsRecommendedBrowser(
        extBrowserName === "chrome" ||
          extBrowserName === "firefox" ||
          extBrowserName === "safari" ||
          extBrowserName === "edge"
      );
    }
  }, []);

  return { isRecommendedBrowser };
};
